import safeLocalStorage from './safeLocalStorage';

export const notifySlack = ({ channel = 'FRONT_MONITORING_CHANNEL', params }) => {
  const baseData = {
    url: window.location.href,
    tracker_id: safeLocalStorage.getItem('userId')
  };

  const data = { ...baseData, ...params }

  fetch(`${window.location.origin}/api/v1/slacks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      channel: channel,
      data: data
    }),
    credentials: 'same-origin'
  });
}
